// removed by extract-text-webpack-plugin
module.exports = {"login-block":"login-block--1jlCKI","logo":"logo--19qonj","btn":"btn--2-Cnhu"};